import {
  Module, VuexModule, getModule, Mutation, Action,
} from '@compassdigital/vuex-module-decorators';

import store from '@/store';

export interface ToastState {
  show: boolean,
  message?: string,
  error?: boolean,
}

@Module({
  dynamic: true,
  namespaced: true,
  name: 'toast',
  store,
})

class ToastModule extends VuexModule implements ToastState {
  public show: boolean = false;

  public message: string = '';

  public error: boolean = false;

  @Mutation
  public toggleToast() {
    this.show = !this.show;
  }

  @Mutation
  public showToast() {
    this.show = true;
  }

  @Mutation
  public hideToast() {
    this.show = false;
  }

  @Mutation
  public setMessage(message: string) {
    this.message = message;
  }

  @Mutation
  public setError(error: boolean) {
    this.error = error;
  }

  @Mutation
  public setVisibility(show: boolean) {
    this.show = show;
  }

  @Action
  public timeoutToast(timeout?: any) {
    if (timeout !== 0) setTimeout(this.hideToast, timeout);
  }

  @Action
  public setToast({
    show = true, message = '', error = false, timeout = 0,
  } = {}) {
    this.setMessage(message);
    this.setVisibility(show);
    this.setError(error);
    this.timeoutToast(timeout);
  }
}

export default getModule(ToastModule);
